let i18next = require('i18next');
i18next = i18next.default || i18next;
exports.t = i18next.getFixedT(null, 'metaschema');
